/**
 * `/j/:token` — the page a journal's share link opens (PLAN-JOURNAL §F).
 *
 * Short and outside `/journals` on purpose, exactly as `/s/:token` sits outside
 * `/recipes`: this URL gets pasted into forum posts and group chats, and it
 * addresses a *token*, not a journal id in anyone's workspace. The root layout
 * renders it without the app shell (see `__root.tsx`), because the visitor has
 * no sidebar, no workspace and no reason to be offered one.
 *
 * Nothing but the token crosses this file. A journal page has no clone and no
 * way into the app — a mead is somebody's record rather than a document to
 * copy — so unlike `/s/:token` there is no callback to pass down.
 */

import { createFileRoute } from '@tanstack/react-router';
import { SharedJournalPage } from '@/components/share/shared-journal';

export const Route = createFileRoute('/j/$token')({
  component: SharedJournalRoute,
});

function SharedJournalRoute() {
  const { token } = Route.useParams();
  return <SharedJournalPage token={token} />;
}
